// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
import vueInsomnia from "vue-insomnia";
import App from './App'
import router from './router'
import LoadScript from 'vue-plugin-load-script';
import Clipboard from 'v-clipboard'

import { library } from '@fortawesome/fontawesome-svg-core';
import {
    faCalendar, faAngleLeft, faAngleRight, faTimes, faTimesCircle, faMinus, faUndoAlt, faSyncAlt, faKey, faUserShield, faUser, faCommentAlt, faDesktop, faChartArea,
    faPaperPlane, faVideo, faVideoSlash, faMicrophone, faMicrophoneSlash, faExclamationCircle, faSignOutAlt, faTrash, faEnvelope, faCheck, faPlus, faVolumeUp, faUpload,
    faPhone, faChevronDown, faChevronUp, faEllipsisV, faList, faToggleOn, faToggleOff, faEye, faEyeSlash, faArrowAltCircleRight, faHistory, faClock, faBan,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(faCalendar, faAngleLeft, faAngleRight, faTimes, faTimesCircle, faMinus, faUndoAlt, faSyncAlt, faKey, faUserShield, faUser, faCommentAlt, faDesktop, faChartArea,
    faPaperPlane, faVideo, faVideoSlash, faMicrophone, faMicrophoneSlash, faExclamationCircle, faSignOutAlt, faTrash, faEnvelope, faCheck, faPlus, faVolumeUp, faUpload,
    faPhone, faChevronDown, faChevronUp, faEllipsisV, faList, faToggleOn, faToggleOff, faEye, faEyeSlash, faArrowAltCircleRight, faHistory, faClock, faBan);
Vue.component('vue-fontawesome', FontAwesomeIcon);

Vue.config.productionTip = false
Vue.use(LoadScript);
Vue.use(Clipboard);
Vue.use(vueInsomnia);
Vue.use(Buefy, {
    defaultIconComponent: 'vue-fontawesome',
    defaultIconPack: 'fas',
})

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js